import { render, staticRenderFns } from "./MedalTable.vue?vue&type=template&id=8d6b115e&scoped=true"
import script from "./MedalTable.vue?vue&type=script&lang=js"
export * from "./MedalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6b115e",
  null
  
)

export default component.exports